//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { makeStyles, DialogTitle, DialogContent, DialogActions, Dialog, DialogContentText } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { setClassNameInDefns } from '../../common/definitionHelper';
import {
    CONFIRM_DIALOG_MESSAGE_DOWNGRADE_SUBSCRIPTION_TIER2,
    CONFIRM_DIALOG_MESSAGE_DOWNGRADE_SUBSCRIPTION_TIER3,
    CONFIRM_DIALOG_TITLE_DOWNGRADE_SUBSCRIPTION,
} from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdButton from '../../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        noButton: { marginRight: 16 },
        title: { fontWeight: 'bold' },
        message: { color: '#111E14' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { props, classes } = params;
    const { open, onClose, onConfirm, color, subscribedTier, selectedTier, yesButtonLoading } = props;

    const confirmDowngradeMessage = subscribedTier === 3 ? CONFIRM_DIALOG_MESSAGE_DOWNGRADE_SUBSCRIPTION_TIER3 : CONFIRM_DIALOG_MESSAGE_DOWNGRADE_SUBSCRIPTION_TIER2;

    const defns = {
        root: { open, maxWidth: 'md', disableBackdropClick: true, disableEscapeKeyDown: true },
        noButton: { onClick: onClose, label: 'No, I changed my mind' },
        yesButton: {
            onClick: onConfirm,
            color: color || 'primary',
            label: yesButtonLoading ? `downgrading to Tier ${selectedTier}...` : `Yes, downgrade to Tier ${selectedTier}`,
            loading: yesButtonLoading,
            disabled: yesButtonLoading,
        },
        message: { variant: 'body1', value: confirmDowngradeMessage },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ConfirmDowngradeDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ props, classes });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Dialog {...defns.root}>
            <DialogTitle>{CONFIRM_DIALOG_TITLE_DOWNGRADE_SUBSCRIPTION}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <AfitdTypography {...defns.message} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <AfitdButton {...defns.noButton} />
                <AfitdButton {...defns.yesButton} />
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDowngradeDialog;
